"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAstra = void 0;
const GUIController_1 = require("./appControllers/GUIController");
const AuthController_1 = require("./appControllers/AuthController");
const StateDashboard_1 = require("./states/StateDashboard");
const gs_1 = require("@ivanlog/gs");
const StateAstra_1 = require("./states/abstracts/StateAstra");
const StateLogin_1 = require("./states/StateLogin");
const DesignThemeEnum_1 = require("./enums/DesignThemeEnum");
const StateProfiles_1 = require("./states/profiles/StateProfiles");
const StateProfile_1 = require("./states/profiles/StateProfile");
const StateVehiclesTypes_1 = require("./states/directory/StateVehiclesTypes");
const StateCreateVehiclesTypes_1 = require("./states/directory/StateCreateVehiclesTypes");
const StateCompanies_1 = require("./states/directory/StateCompanies");
const StateComany_1 = require("./states/directory/StateComany");
const StateVehicles_1 = require("./states/directory/StateVehicles");
const StateVehicle_1 = require("./states/directory/StateVehicle");
const AstraController_1 = require("./appControllers/AstraController");
const StateRatesAreas_1 = require("./states/directory/StateRatesAreas");
const StateRatesArea_1 = require("./states/directory/StateRatesArea");
const StateRates_1 = require("./states/directory/StateRates");
const StateRate_1 = require("./states/directory/StateRate");
const StateCoupons_1 = require("./states/directory/StateCoupons");
const StateCoupon_1 = require("./states/directory/StateCoupon");
const StateHolidays_1 = require("./states/directory/StateHolidays");
const StateDrivers_1 = require("./states/directory/StateDrivers");
const StateDriver_1 = require("./states/directory/StateDriver");
const StateProfileCreateByPhone_1 = require("./states/profiles/StateProfileCreateByPhone");
const StateCustomerNewOrder_1 = require("./states/customer/StateCustomerNewOrder");
const StateCustomerOrders_1 = require("./states/customer/StateCustomerOrders");
const StateCustomerOrder_1 = require("./states/customer/StateCustomerOrder");
const StateDriverOrders_1 = require("./states/drivers/StateDriverOrders");
const StateDriverWork_1 = require("./states/drivers/StateDriverWork");
const StateDriverDelayedOrders_1 = require("./states/drivers/StateDriverDelayedOrders");
const StateActiveOrders_1 = require("./states/activeManager/StateActiveOrders");
const StateOrders_1 = require("./states/activeManager/StateOrders");
const StateActiveDrivers_1 = require("./states/activeManager/StateActiveDrivers");
const StateDriverHotOrders_1 = require("./states/drivers/StateDriverHotOrders");
const StateOrder_1 = require("./states/activeManager/StateOrder");
const LongPollController_1 = require("./appControllers/LongPollController");
const APIsConnector_1 = require("./appControllers/APIsConnector");
class AppAstra {
    constructor() {
        StateAstra_1.StateAstra.App = this;
        gs_1.StateGS.DefaultStateName = "loading";
        this.api = new APIsConnector_1.default(this);
        this.auth = new AuthController_1.AuthController(this);
        this.gui = new GUIController_1.GUIController(this);
        this.astra = new AstraController_1.AstraController(this);
        this.longPolling = new LongPollController_1.default(this, APIsConnector_1.default.APIUrl);
        //this.api.customer.e
        this.auth.onLogout.addHandler(() => {
            gs_1.StateGS.Run(StateLogin_1.StateLogin);
        });
        this.auth.onLogin.addHandler((session) => {
            if (!session.user.name)
                //If user is new - need feel data
                gs_1.StateGS.Run(StateProfile_1.StateProfile, { id: session.user.id.toString() });
            else
                gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
        });
        this.gui.setTheme(DesignThemeEnum_1.DesignThemeEnum.LightGrey);
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            gs_1.StateGS.RegState(StateLogin_1.StateLogin);
            gs_1.StateGS.RegState(StateDashboard_1.StateDashboard);
            gs_1.StateGS.RegState(StateProfiles_1.StateProfiles);
            gs_1.StateGS.RegState(StateProfile_1.StateProfile);
            gs_1.StateGS.RegState(StateProfileCreateByPhone_1.StateProfileCreateByPhone);
            gs_1.StateGS.RegState(StateCompanies_1.StateCompanies);
            gs_1.StateGS.RegState(StateComany_1.StateCompany);
            gs_1.StateGS.RegState(StateVehicles_1.StateVehicles);
            gs_1.StateGS.RegState(StateVehicle_1.StateVehicle);
            gs_1.StateGS.RegState(StateRatesAreas_1.StateRatesAreas);
            gs_1.StateGS.RegState(StateRatesArea_1.StateRatesArea);
            gs_1.StateGS.RegState(StateRates_1.StateRates);
            gs_1.StateGS.RegState(StateRate_1.StateRate);
            gs_1.StateGS.RegState(StateCoupons_1.StateCoupons);
            gs_1.StateGS.RegState(StateCoupon_1.StateCoupon);
            gs_1.StateGS.RegState(StateHolidays_1.StateHolidays);
            gs_1.StateGS.RegState(StateDrivers_1.StateDrivers);
            gs_1.StateGS.RegState(StateDriver_1.StateDriver);
            gs_1.StateGS.RegState(StateVehiclesTypes_1.StateVehiclesTypes);
            gs_1.StateGS.RegState(StateCreateVehiclesTypes_1.StateCreateVehiclesTypes);
            gs_1.StateGS.RegState(StateCustomerNewOrder_1.StateCustomerNewOrder);
            gs_1.StateGS.RegState(StateCustomerOrders_1.StateCustomerOrders);
            gs_1.StateGS.RegState(StateCustomerOrder_1.StateCustomerOrder);
            gs_1.StateGS.RegState(StateDriverOrders_1.StateDriverOrders);
            gs_1.StateGS.RegState(StateDriverWork_1.StateDriverWork);
            gs_1.StateGS.RegState(StateDriverDelayedOrders_1.StateDriverDelayedOrders);
            gs_1.StateGS.RegState(StateActiveOrders_1.StateActiveOrders);
            gs_1.StateGS.RegState(StateActiveDrivers_1.StateActiveDrivers);
            gs_1.StateGS.RegState(StateDriverHotOrders_1.StateDriverHotOrders);
            gs_1.StateGS.RegState(StateOrders_1.StateOrders);
            gs_1.StateGS.RegState(StateOrder_1.StateOrder);
            StateDriverHotOrders_1.StateDriverHotOrders.InitEventsHandles();
            StateCustomerOrders_1.StateCustomerOrders.InitEventsHandles();
            gs_1.StateGS.DefaultStateName = StateDashboard_1.StateDashboard.StateName;
            yield this.auth.start();
            yield this.astra.start();
            if (this.auth.isAuth) {
                if ((yield gs_1.StateGS.RunByUrl()) === gs_1.StateRunResultEnum.Failed)
                    yield gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
            }
            else {
                yield gs_1.StateGS.Run(StateLogin_1.StateLogin);
            }
        });
    }
}
exports.AppAstra = AppAstra;
AppAstra.version = "1.1.0";
//# sourceMappingURL=AppAstra.js.map